import { useStore } from 'effector-react'
import { QUERY_KEY_LIST_BALANCE_HISTORIES } from '~/features/BalanceHistories/ListBalanceHistories'
import { balanceHistoriesModel } from '~/entities/BalanceHistories'
import { useRefreshList } from '~/shared/ui/ScrollableList'

export const useRefreshPage = () => {
  const instanceFnBalanceReportForDay = useStore(
    balanceHistoriesModel.$instanceFnBalanceReportForDay,
  )
  const { refreshList } = useRefreshList(QUERY_KEY_LIST_BALANCE_HISTORIES)

  const refreshPage = async () => {
    await Promise.all([refreshList(), instanceFnBalanceReportForDay?.()])
  }

  return { refreshPage }
}
